// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.radio-list__item {
    display: flex;
    align-items: center;
}

.radio-list__input {
    cursor: pointer;
}

.radio-list__label {
    cursor: pointer;
    font-size: 1rem;
    transition: color 0.2s ease, font-weight 0.2s ease;
}

.radio-list__label--selected {
    color: #007bff;
    font-weight: bold;
}

.radio-label-container {
    display: flex;
    align-items: center; /* Align text and icon vertically */
    gap: 8px; /* Adjust this value to increase/decrease the space */
}

.info-icon-spacing {
    margin-left: 8px; /* Extra spacing for fine-tuning */
}
`, "",{"version":3,"sources":["webpack://./src/radio-list.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,mCAAmC;IACxD,QAAQ,EAAE,qDAAqD;AACnE;;AAEA;IACI,gBAAgB,EAAE,kCAAkC;AACxD","sourcesContent":[".radio-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.radio-list__item {\n    display: flex;\n    align-items: center;\n}\n\n.radio-list__input {\n    cursor: pointer;\n}\n\n.radio-list__label {\n    cursor: pointer;\n    font-size: 1rem;\n    transition: color 0.2s ease, font-weight 0.2s ease;\n}\n\n.radio-list__label--selected {\n    color: #007bff;\n    font-weight: bold;\n}\n\n.radio-label-container {\n    display: flex;\n    align-items: center; /* Align text and icon vertically */\n    gap: 8px; /* Adjust this value to increase/decrease the space */\n}\n\n.info-icon-spacing {\n    margin-left: 8px; /* Extra spacing for fine-tuning */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
